import Vue from 'vue';
if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}
import App from '../../App.vue';
import router from '../rooters/pc';
import store from '../stores/pc';

import VueClipboards from 'vue-clipboard2'
Vue.use(VueClipboards);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#h5-pc');
